// Version : 0.0.1
// Author : Vignesh
const IndividualLoanActionTypes = {
	/** ***************** ADD INDIVIDUAL LOAN PROPOSAL START ***************** */
	ADD_INDIVIDUAL_LOAN_PROPOSAL_START: 'add_individual_loan_proposal_start',
	ADD_INDIVIDUAL_LOAN_PROPOSAL_SUCCESS: 'add_individual_loan_proposal_success',
	ADD_INDIVIDUAL_LOAN_PROPOSAL_FAILURE: 'add_individual_loan_proposal_failure',
	ADD_INDIVIDUAL_LOAN_PROPOSAL_RESPONSE_RESET: 'add_individual_loan_proposal_response_reset',
	ADD_INDIVIDUAL_LOAN_PROPOSAL_RESPONSE_CHANGED: 'add_individual_loan_proposal_response_changed',
	/** ***************** ADD INDIVIDUAL LOAN PROPOSAL END ***************** */

	/** ***************** UPDATE INDIVIDUAL LOAN PROPOSAL START ***************** */
	UPDATE_INDIVIDUAL_LOAN_PROPOSAL_START: 'update_individual_loan_proposal_start',
	UPDATE_INDIVIDUAL_LOAN_PROPOSAL_SUCCESS: 'update_individual_loan_proposal_success',
	UPDATE_INDIVIDUAL_LOAN_PROPOSAL_FAILURE: 'update_individual_loan_proposal_failure',
	UPDATE_INDIVIDUAL_LOAN_PROPOSAL_RESPONSE_RESET:
		'update_individual_loan_proposal_response_reset',
	UPDATE_INDIVIDUAL_LOAN_PROPOSAL_RESPONSE_CHANGED:
		'update_individual_loan_proposal_response_changed',
	/** ***************** UPDATE INDIVIDUAL LOAN PROPOSAL END ***************** */

	/** ***************** SEARCH MEMBER LOAN PROPOSAL START ***************** */
	SEARCH_MEMBER_LOAN_PROPOSAL_START: 'search_member_loan_proposal_start',
	SEARCH_MEMBER_LOAN_PROPOSAL_SUCCESS: 'search_member_loan_proposal_success',
	SEARCH_MEMBER_LOAN_PROPOSAL_FAILURE: 'search_member_loan_proposal_failure',
	SEARCH_MEMBER_LOAN_PROPOSAL_RESPONSE_RESET: 'search_member_loan_proposal_response_reset',
	SEARCH_MEMBER_LOAN_PROPOSAL_RESPONSE_CHANGED: 'search_member_loan_proposal_response_changed',
	/** ***************** SEARCH MEMBER LOAN PROPOSAL END ***************** */
};

export default IndividualLoanActionTypes;
